var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v(_vm._s(_vm.$t("delegationOrder.decision.title")))]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c(
          "div",
          { staticClass: "pa-4" },
          [
            _c("delegation-order-decision-form", {
              attrs: { "delegation-decision": _vm.delegationDecision },
              on: {
                "update:delegationDecision": function($event) {
                  _vm.delegationDecision = $event
                },
                "update:delegation-decision": function($event) {
                  _vm.delegationDecision = $event
                },
                accept: _vm.accept,
                deny: _vm.deny,
                denyAndRevert: _vm.denyAndRevert,
                downloadSettlement: _vm.downloadSettlement
              }
            })
          ],
          1
        ),
        _c(
          "v-card",
          { staticClass: "grey lighten-4" },
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$router.push("/delegation-order")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }